
import { Vue } from "vue-class-component";

export default class TheHeader extends Vue {}
